import { useEffect, useRef } from "react";

// Helper hook
const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

// Compares previous ref of the value and returns whether the value changed from previous render
const useCompare = (val) => {
  const prevVal = usePrevious(val);
  return prevVal !== val;
};

export { useCompare };
